export default "__VITE_ASSET__DIS7Fefb__"